<section id="contact" class="relative scroll-mt-28 overflow-hidden border-t border-surface">
    <div class="contact-hex-field" aria-hidden="true">
        @for (row of hexRows; track $index) {
            <div class="contact-hex-row" [class.is-offset]="row.offset">
                @for (hex of row.cells; track $index) {
                    <span class="contact-hex" [style.animation-delay.s]="hex.delay"></span>
                }
            </div>
        }
    </div>

    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="pipeline-contact-panel relative overflow-hidden rounded-[2rem] border border-surface bg-surface-50 p-8 shadow-[0_40px_120px_rgba(0,0,0,0.08)] sm:p-10 lg:p-12">
            <div class="relative z-10 grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
                <div>
                    <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().contactTitle }}</div>
                    <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().contactSubtitle }}</h2>
                    <p class="mt-6 max-w-2xl text-lg leading-8 text-muted-color">{{ text().contactDescription }}</p>

                    <div class="mt-8 space-y-5">
                        @for (benefit of text().contactBenefits; track benefit.title; let i = $index) {
                            <div [appRevealOnScroll]="i * 90" class="flex items-start gap-4">
                                <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary dark:bg-white/10">
                                    <i class="pi" [ngClass]="contactBenefitIcons()[i]"></i>
                                </span>
                                <div>
                                    <div class="font-semibold text-surface-900 dark:text-white">{{ benefit.title }}</div>
                                    <p class="mt-1 text-sm leading-6 text-muted-color">{{ benefit.description }}</p>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div class="rounded-[1.75rem] border border-surface bg-surface-0 p-6 dark:bg-surface-950/80 sm:p-8">
                    <form [formGroup]="demoForm()" (ngSubmit)="submitDemo.emit()" class="flex flex-col gap-5">
                        <div class="grid gap-5 sm:grid-cols-2">
                            <div class="flex flex-col gap-2">
                                <label for="demo-company" class="text-sm font-medium text-surface-900 dark:text-white">{{ text().demoCompanyLabel }} <span class="text-red-500">*</span></label>
                                <input pInputText id="demo-company" type="text" formControlName="company" class="w-full" />
                            </div>
                            <div class="flex flex-col gap-2">
                                <label for="demo-full-name" class="text-sm font-medium text-surface-900 dark:text-white">{{ text().demoFullNameLabel }} <span class="text-red-500">*</span></label>
                                <input pInputText id="demo-full-name" type="text" formControlName="fullName" class="w-full" />
                            </div>
                        </div>

                        <div class="grid gap-5 sm:grid-cols-2">
                            <div class="flex flex-col gap-2">
                                <label for="demo-phone" class="text-sm font-medium text-surface-900 dark:text-white">{{ text().demoPhoneLabel }} <span class="text-red-500">*</span></label>
                                <input pInputText id="demo-phone" type="tel" formControlName="phone" required class="w-full" />
                            </div>
                            <div class="flex flex-col gap-2">
                                <label for="demo-email" class="text-sm font-medium text-surface-900 dark:text-white">{{ text().demoEmailLabel }} <span class="text-red-500">*</span></label>
                                <input pInputText id="demo-email" type="email" formControlName="email" class="w-full" />
                            </div>
                        </div>

                        <div class="flex flex-col gap-2">
                            <label for="demo-message" class="text-sm font-medium text-surface-900 dark:text-white">{{ text().demoMessageLabel }}</label>
                            <textarea pTextarea id="demo-message" rows="4" formControlName="message" [placeholder]="text().demoMessagePlaceholder" class="w-full"></textarea>
                        </div>

                        @if (demoSubmitted()) {
                            <div class="rounded-xl border border-green-500/30 bg-green-500/10 px-4 py-3 text-sm font-medium text-green-600 dark:text-green-400">
                                {{ text().demoSuccessMessage }}
                            </div>
                        }

                        <p-button type="submit" [label]="text().demoSubmitLabel" styleClass="w-full justify-center"></p-button>

                        <p class="text-center text-xs leading-5 text-muted-color">{{ text().demoFootnote }}</p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
